import _isConstructor from "../internals/is-constructor";
import _tryToString from "../internals/try-to-string";
var exports = {};
var isConstructor = _isConstructor;
var tryToString = _tryToString;
var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + " is not a constructor");
};
export default exports;